<template>
    <div>
        <h1>개인정보 수집·이용 동의</h1>
        주식회사 솔닥(이하 “회사”)은 제휴사 임직원 할인쿠폰 발급 서비스를 제공하기 위해 아래와 같이 개인정보를 수집·이용합니다. 아래 내용을 확인하신 후 동의 여부를 결정해 주시기 바랍니다.<br>
        <br>
        <table class="table" border="1">
            <thead>
                <tr>
                    <th style="width: 15%;">구분</th>
                    <th style="width: 40%;">수집 및 이용 목적</th>
                    <th style="width: 25%;">수집 항목</th>
                    <th style="width: 20%;">비고</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>쿠폰 발송</td>
                    <td>제휴사 임직원 여부 확인, 할인쿠폰 발송, 발급 한도(1인 월 1회) 관리</td>
                    <td>회사 이메일 주소</td>
                    <td>&nbsp;</td>
                </tr>
            </tbody>
        </table>
        <br>
        ※ 귀하는 개인정보 수집·이용에 대한 동의를 거부하실 수 있습니다. 다만 동의하지 않으실 경우 임직원 확인이 불가능하여 할인쿠폰을 발급받으실 수 없습니다.
    </div>
</template>

<script>
export default {
    name: 'employeeCouponConsent'
}
</script>

<style scoped>
    .table {
      width: 100%;
      border-collapse: collapse;
      word-break: break-word;
    }
    th, td {
      padding: 8px;
      vertical-align: top;
      text-align: left;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/EmployeeCouponConsent.vue